import { Latng } from './latng';
import LatLngLiteral = google.maps.LatLngLiteral;

export class Path {

  forecastPath: Array<Latng>;

  public static fromDto(d: any): Path {
    if (!d) {
      return null;
    }

    const path = new Path();

    path.forecastPath = d.forecast_path || [];

    return path
  }

  getForecastPathLatLngLiteral(): Array<LatLngLiteral> {
    return this.forecastPath ?
      this.forecastPath.map(coord => { return {lat: coord.latitude, lng: coord.longitude}; }) : [];
  }
}
